import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartCodeBookImportMutationVariables = Types.Exact<{
  input: Types.StartCodeBookImportInput;
}>;


export type StartCodeBookImportMutation = { __typename?: 'mutation_root', start_code_book_import?: { __typename?: 'CodeBookImportStartedOutput', import_id: any, status: string } | null };


export const StartCodeBookImportDocument = gql`
    mutation startCodeBookImport($input: StartCodeBookImportInput!) {
  start_code_book_import(input: $input) {
    import_id
    status
  }
}
    `;
export type StartCodeBookImportMutationFn = Apollo.MutationFunction<StartCodeBookImportMutation, StartCodeBookImportMutationVariables>;

/**
 * __useStartCodeBookImportMutation__
 *
 * To run a mutation, you first call `useStartCodeBookImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCodeBookImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCodeBookImportMutation, { data, loading, error }] = useStartCodeBookImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartCodeBookImportMutation(baseOptions?: Apollo.MutationHookOptions<StartCodeBookImportMutation, StartCodeBookImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCodeBookImportMutation, StartCodeBookImportMutationVariables>(StartCodeBookImportDocument, options);
      }
export type StartCodeBookImportMutationHookResult = ReturnType<typeof useStartCodeBookImportMutation>;
export type StartCodeBookImportMutationResult = Apollo.MutationResult<StartCodeBookImportMutation>;
export type StartCodeBookImportMutationOptions = Apollo.BaseMutationOptions<StartCodeBookImportMutation, StartCodeBookImportMutationVariables>;